import React, { useState, useEffect } from "react";
import { db } from "../../../firebaseConfig";
import {
  getDoc,
  doc,
  updateDoc,
  arrayUnion,
  arrayRemove,
} from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import Main from "../../Pages/Home/Main";
// Slike
import NKPodsusedBijelaBg from "../../../Assets/Images/Ostalo/NK-Podsused-Bijela-Bg.jpg";
import NKPodsusedBijelaPhoneBg from "../../../Assets/Images/Ostalo/NK-Podsused-Bijela-Phone-Bg.jpg";
import Ball from "../../../Assets/Images/Ostalo/Ball.png";

// List of available players
const playersList = [
  "G. Bašić",
  "Z. Kovačić",
  "L. Barun",
  "A. Boras",
  "A. Božić",
  "R. Budiselić",
  "A. Čelić",
  "L. Čengić",
  "R. Fliszar",
  "L. Galinec",
  "J. Gotal",
  "M. Hojsak",
  "J. Jambrek",
  "I. Jambrišak",
  "J. Jozić",
  "J. Jurić",
  "M. Kirasić",
  "M. Lipovac",
  "J. Mesić",
  "T. Mešin",
  "K. Mihelčić",
  "D. Mihoković",
  "K. Minković",
  "P. Oršulić",
  "M. Perković",
  "T. Posavec",
  "J. Putanec",
  "J. Račić",
  "M. Sedmak",
  "L. Nerat",
  "M. Stunja",
  "L. Vidović",
  "M. Vinković",
];

export default function AddPlayers({ updatePlayers }) {
  const [availablePlayers, setAvailablePlayers] = useState(playersList);
  const [selectedPlayer, setSelectedPlayer] = useState("");
  const [goals, setGoals] = useState(0);
  const [addedPlayers, setAddedPlayers] = useState([]); // Keep track of added players
  const [showForm, setShowForm] = useState(false); // Show/hide form
  const [editingPlayer, setEditingPlayer] = useState(null); // Currently editing player
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPlayers = async () => {
      const docRef = doc(db, "podsused", "podsused");
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const data = docSnap.data();
        // Sort players by goals first, then by last name
        const sortedPlayers = (data.strijelci || []).sort((a, b) => {
          if (b.goals === a.goals) {
            // Compare by last name if goals are equal
            const lastNameA = a.name.split(" ").pop();
            const lastNameB = b.name.split(" ").pop();
            return lastNameA.localeCompare(lastNameB);
          }
          return b.goals - a.goals; // Sort by goals in descending order
        });

        setAddedPlayers(sortedPlayers); // Update the state with sorted players
      }
    };

    fetchPlayers();
  }, []);

  const handleAddPlayer = async () => {
    if (selectedPlayer.trim() !== "" && goals > 0) {
      try {
        const docRef = doc(db, "podsused", "podsused");

        // Prepare new player object
        const newPlayer = {
          name: selectedPlayer,
          goals: parseInt(goals),
        };

        // Add player to Firestore within the 'strijelci' array
        await updateDoc(docRef, {
          strijelci: arrayUnion(newPlayer),
        });

        // Update local state
        setAddedPlayers((prev) => [...prev, newPlayer]);
        updatePlayers(newPlayer);

        // Remove added player from available players
        setAvailablePlayers(
          availablePlayers.filter((player) => player !== selectedPlayer),
        );

        // Reset inputs
        resetInputs();
      } catch (e) {
        console.error("Error adding document: ", e);
      }
    } else {
      alert("Molimo odaberite igrača i unesite broj golova.");
    }
  };

  const resetInputs = () => {
    setSelectedPlayer("");
    setGoals(0);
    setShowForm(false); // Hide form after adding
    setEditingPlayer(null); // Reset editing state
  };

  const handleRemovePlayer = async (playerToRemove) => {
    try {
      const docRef = doc(db, "podsused", "podsused");

      // Remove player from Firestore
      await updateDoc(docRef, {
        strijelci: arrayRemove(playerToRemove), // Remove from the Firestore array
      });

      // Update local state
      setAddedPlayers((prev) =>
        prev.filter((player) => player.name !== playerToRemove.name),
      );

      // Return player back to available
      setAvailablePlayers((prev) => [...prev, playerToRemove.name]);
    } catch (error) {
      console.error("Error removing player: ", error);
    }
  };

  const handleEditPlayer = (player) => {
    setEditingPlayer(player); // Set player being edited
    setGoals(player.goals); // Set current goals in input
    setShowForm(false); // Hide add form when editing
  };

  const handleUpdatePlayer = async () => {
    try {
      const docRef = doc(db, "podsused", "podsused");

      // Create a copy of added players with updated goals
      const updatedPlayers = addedPlayers.map((player) =>
        player.name === editingPlayer.name
          ? { ...player, goals: parseInt(goals) }
          : player,
      );

      // Update Firestore with the new list of players
      await updateDoc(docRef, {
        strijelci: updatedPlayers,
      });

      // Update local state
      setAddedPlayers(updatedPlayers);

      resetInputs(); // Reset fields and hide form
    } catch (error) {
      console.error("Error updating player: ", error);
    }
  };

  return (
    <>
      <Main
        desktopBackground={NKPodsusedBijelaBg}
        phoneBackground={NKPodsusedBijelaPhoneBg}
        title="DODAJ STRIJELCE"
      />
      <div className="section">
        <button
          className="go-back-btn"
          onClick={() => navigate("/admin/dashboard")}
        >
          Vrati se nazad
        </button>
        <div>
          {/* Button to show form */}
          {!showForm && !editingPlayer && (
            <button className="add-btn" onClick={() => setShowForm(true)}>
              Dodaj novog strijelca
            </button>
          )}
        </div>

        {/* Form for adding player */}
        {showForm && !editingPlayer && (
          <div className="addMatches-form">
            <label>Odaberi igrača:</label>
            <select
              value={selectedPlayer}
              onChange={(e) => setSelectedPlayer(e.target.value)}
            >
              <option value="">Odaberite igrača</option>
              {availablePlayers.map((player, index) => (
                <option key={index} value={player}>
                  {player}
                </option>
              ))}
            </select>
            <label>Unesi broj golova:</label>
            <input
              type="number"
              placeholder="Golovi"
              value={goals}
              onChange={(e) => setGoals(e.target.value)}
            />
            <button className="add-btn" onClick={handleAddPlayer}>
              Spremi
            </button>
            <button className="remove-btn" onClick={resetInputs}>
              Odustani
            </button>{" "}
            {/* Button to close form */}
          </div>
        )}

        {/* Form for editing player */}
        {editingPlayer && (
          <div className="form">
            <p>
              <span>Uređivanje igrača:</span> {editingPlayer.name}
            </p>
            <p>Broj golova:</p>
            <input
              type="number"
              placeholder="Golovi"
              value={goals}
              onChange={(e) => setGoals(e.target.value)}
            />
            <button className="add-btn" onClick={handleUpdatePlayer}>
              Spremi promjene
            </button>
            <button
              className="remove-btn"
              onClick={() => {
                resetInputs(); // Ensure form is hidden after canceling
              }}
            >
              Odustani
            </button>{" "}
            {/* Button to close form */}
          </div>
        )}

        {/* Display added players with edit and remove buttons */}
        {addedPlayers.length > 0 && (
          <ul className="added-players-list">
            {addedPlayers.map((player) => (
              <li key={player.name} className="added-player-item">
                <span>
                  {player.name} - {player.goals} <img src={Ball} alt="Lopta" />
                </span>
                <div className="button">
                  <button
                    className="add-btn"
                    onClick={() => handleEditPlayer(player)}
                  >
                    Uredi
                  </button>
                  <button
                    className="remove-btn"
                    onClick={() => handleRemovePlayer(player)}
                  >
                    Ukloni
                  </button>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </>
  );
}
